import {Component, Input, OnInit} from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';
import {ActionsService} from '../../services/actions.service';

@Component({
  selector: 'app-actions-date-list',
  templateUrl: './actions-date-list.component.html',
  styleUrls: ['./actions-date-list.component.scss']
})
export class ActionsDateListComponent extends ModalExtended implements OnInit {

    actions: Array<Object> = [];
    data: Object = {};
    enabled: boolean = false;

    constructor(private actionsHandler: ActionsService) {
        super();
    }

    onExit(): void {
        this.close();
    }

    ngOnInit() {
        this.enabled = true;
        this.actionsHandler.findActions(this.data).subscribe(
            (result) => {
                this.actions = result;
                this.enabled = false;
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/actions-date-list/actions-date-list.component.ts